export const FILTER_SELECTOR_DROPDOWN_CLASSNAME = 'FILTER_SELECTOR_DROPDOWN_CLASSNAME';
export const TENDERS_LIST_FILTER_WRAPPER_CLASSNAME =
  'TENDERS_LIST_FILTER_WRAPPER_CLASSNAME';
